import React from 'react';

const LCVViewBoard = ({phase, term}) => {
  const label = (() => {
    if (phase === 'frontloading') return 'LESSON VISUAL';
    if (phase === 'mastery') return 'MASTERY TEST';
    if (phase === 'results') return 'RESULTS';
    return term?.term?.toUpperCase() || '[viewboardImage]';
  })();

  const caption = (() => {
    if (phase === 'frontloading') return 'Supporting visual for vocabulary overview';
    if (phase === 'mastery') return 'Answer each question to complete the mastery test';
    return `Visual for: ${term?.term || ''}`;
  })();

  return (
    <div className="lcv-viewboard">
      <div className="lcv-viewboard-frame">
        <div className="lcv-viewboard-image">
          <div className="lcv-vb-placeholder">
            <div className="lcv-vb-icon">🖼️</div>
            <span>[viewboardImage]</span>
            <span style={{fontSize: 9}}>AI-generated visual placeholder</span>
          </div>
        </div>
        <div className="lcv-viewboard-caption">
          <div className="lcv-vb-cap-label">{label}</div>
          {caption}
        </div>
      </div>
    </div>
  );
};

export default LCVViewBoard;
